import React from 'react';
import moment from 'moment';
import { useIntl } from 'react-intl';
import messages from './FieldMessages';

const UboLine = props => {
  const intl = useIntl();
  const { log } = props;

  const added = !!(log.oldValue === null && log.newValue !== null);
  const dateTime = moment(added ? new Date(log.newValue) : new Date(log.oldValue));
  const time = dateTime.format('LLLL');
  const message = added ? messages.AddedAnUboSnapshotAt : messages.DeletedAnUboSnapshotAt;

  return <span>{intl.formatMessage(message, { time, i: value => <i>{value}</i> })}</span>;
};

export default UboLine;
